import { render, staticRenderFns } from "./DspConfigurationDetails.vue?vue&type=template&id=881c934a&lang=pug"
import script from "./DspConfigurationDetails.vue?vue&type=script&lang=js"
export * from "./DspConfigurationDetails.vue?vue&type=script&lang=js"
import style0 from "./DspConfigurationDetails.vue?vue&type=style&index=0&id=881c934a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports